import { _APP_CONFIG } from "../../core/config/AppConfig";
import { DataDRequest } from "../DRequest";
import { Entidad } from "../Entidad";

export async function _FinanzasObtenerPagosPorRecibirV2(idEscuela: number): Promise<DataDRequest.IRequestResponseA<Entidad.IFinanzaPagoPendiente[]>> {
    const url = _APP_CONFIG.URL_RSTV2 + "finanzas/ObtenerPagosPorRecibirV2";
    const params = {
        IdEscuela: idEscuela
    }
    return DataDRequest._Request5(url, "GET", params, { idToKeepPromiseUntilFinished: idEscuela })
}
